import { render, staticRenderFns } from "./HuaxianIndexNews.vue?vue&type=template&id=4a6c8d42&scoped=true&"
import script from "./HuaxianIndexNews.vue?vue&type=script&lang=js&"
export * from "./HuaxianIndexNews.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianIndexNews.vue?vue&type=style&index=0&id=4a6c8d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c8d42",
  null
  
)

export default component.exports